import React from 'react'
import { UserOutlined } from '@ant-design/icons'

import { LntDropdown, LntAvatar, LntButton } from '@app/components/base'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { AccountInfoProps } from './types'

export const AccountInfo: React.FC<AccountInfoProps> = ({ accountInfoMenu, avatar, position, fullName }) => {
  return (
    <LntDropdown
      trigger={ ['click'] }
      items={ accountInfoMenu }
    >
      <LntButton
        type={ BUTTON_TYPE.text }
        size={ SIZE.middle }
        className={ styles.accountInfo }
      >
        <p className={ styles.accountInfo__info }>
          <span className={ styles.accountInfo__fullName }>{ fullName }</span>
          <span className={ styles.accountInfo__position }>{ position }</span>
        </p>

        <LntAvatar
          size={ SIZE.large }
          src={ avatar }
        >
          <UserOutlined />
        </LntAvatar>
      </LntButton>
    </LntDropdown>
  )
}
